
import { Vue, Component, Prop } from 'vue-property-decorator';
import DomainList from '@/components/DomainList.vue';
import TopBar from '@/components/TopBar.vue';
import Background from '@/components/Background.vue';
import RegisterButton from '@/components/RegisterButton.vue';
import {MutationType, RouteName, SiteId} from '@/enums';
import { t } from '@/utils';
import store from "@/store";
import BackButton from "@/components/BackButton.vue";
import {isVariationDiet} from "@/utils/common";
import FoodInfoButton from "@/components/FoodInfoButton.vue";
import FoodInfoPopup from "@/components/FoodInfoPopup.vue";

@Component({
	components: {
		FoodInfoPopup,
		FoodInfoButton,
		BackButton,
		DomainList,
		TopBar,
		Background,
		RegisterButton
	}
})
export default class Overview extends Vue {
	private showInfoPopup:boolean = false;

	beforeMount() {
		this.$store.commit(MutationType.SET_CURRENT_DOMAIN, null);
		this.$store.commit(MutationType.SET_CURRENT_CHAPTER, null);
		this.$store.commit(MutationType.SET_CURRENT_THEME, null);
	}

	private clickBackButton(): void {
		this.$router.push({
			name: RouteName.PRE_QUESTION_SURVEY
		});
	}

	private toggleShowInfoPopup(): void {
		this.showInfoPopup = !this.showInfoPopup;
	}

	private endRegistration(): void {
		// continue pop up
		/* let confirmQuestion = t('overview', 'finish_confirmation');

		if (!confirm(confirmQuestion)) {
			return;
		}*/

		if (isVariationDiet()) {
			this.$router.push({
				name: RouteName.RESULT
			});
		} else {
			this.$router.push({
				name: RouteName.OUTRO
			});
		}
	}
}
